import React from "react";
export function Community() {
  return <section id="comunidad" className="mx-auto max-w-5xl px-6 py-16 sm:py-24" data-id="element-27" data-mp="335bhk5bdrscu">
      <p className="mb-3 font-semibold text-accent" data-id="element-28" data-mp="csj9kxeayisu">Formación + comunidad + acompañamiento</p>
      <h2 className="mb-6 font-serif text-[30px] font-bold leading-tight sm:text-5xl" data-id="element-29" data-mp="hllygs84x42p">
        No tenés que resolver todo por tu cuenta
      </h2>
      <div className="rounded-2xl border border-accent/40 bg-ink-2 p-7 sm:p-10" data-id="element-30" data-mp="mlhzciljcfe1">
        <h3 className="font-serif text-2xl font-bold text-accent" data-id="element-31" data-mp="3l3dtkfhki454">Dos asesorías semanales con Marcos</h3>
        <p className="mt-4 text-xl font-semibold" data-id="element-32" data-mp="3q2gq1bjhf21h">Miércoles y viernes</p>
        <p className="mt-4 leading-relaxed text-soft" data-id="element-33" data-mp="3uxvz7q6jo9rk">
          Traé tus dudas sobre el ebook, la oferta o la venta. En estos encuentros trabajamos sobre los pasos que
          necesitás dar para avanzar.
        </p>
        <p className="mt-4 leading-relaxed text-soft" data-id="element-34" data-mp="1abcbexy15zx8">
          Además, accedés a la formación y a la comunidad en Skool para compartir tu proceso con otras personas que
          también están creando su producto digital.
        </p>
      </div>
    </section>;
}